/**
 *
 * @des 登录模块
 *
 */

// import store from '@/store/index'

import { post, prefix,prefixKey ,get} from './base'

// 获取手机验证码
export function requestSMSCode(params) {
    return post(prefix + 'passport/v1/login/requestSMSCode', params)
}

// 验证码登录
export function verifySMSCode(params) {
    return post(prefix + 'passport/v1/login/SMSCode', params)
}

// 密码登录
export function verifyPassword(params) {
    return post(prefix + 'passport/v1/login/password', params)
}

// 加入企业
export function joinCompany(params) {
    return post(prefix + 'joinCompany', params)
}

export function getSignResult(params) {
    return post(prefix + 'open/sign/getSignResult', params)
}
//获取公钥
export function getPubKey(params) {
    return get(prefixKey + 'usp/get_pub_key', params)
}
